import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#e69055',
    },
    secondary: {
      main: '#19857b',
    },
  },
});

export default theme;
